import type { Variants, Transition } from 'framer-motion';

// Shared spring config — natural, no overshoot
export const spring: Transition = {
  type: 'spring',
  stiffness: 100,
  damping: 20,
  mass: 0.8,
};

// Snappy spring for UI elements
export const springSnap: Transition = {
  type: 'spring',
  stiffness: 300,
  damping: 30,
};

// Fade up — the workhorse reveal animation
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
};

// Fade in — no movement, just opacity
export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

// Scale up from center
export const scaleUp: Variants = {
  hidden: { opacity: 0, scale: 0.85 },
  visible: { opacity: 1, scale: 1 },
};

// Stagger children container
export const staggerContainer: Variants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.15,
    },
  },
};

// Stagger with custom delay
export function stagger(staggerDelay = 0.1, startDelay = 0.15): Variants {
  return {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: staggerDelay,
        delayChildren: startDelay,
      },
    },
  };
}

// Word-by-word text split helper
export function splitWords(text: string): string[] {
  return text.split(' ');
}

// Character split helper
export function splitChars(text: string): string[] {
  return text.split('');
}

// Default viewport trigger for useInView
export const viewportOnce = {
  triggerOnce: true,
  threshold: 0.15,
  rootMargin: '-40px 0px',
} as const;
